export default __webpack_public_path__ + "images/models/12d2527c8fe3414896285dd242f84b6d.usdz";